import React from 'react';

import styled from 'styled-components';

type OwnProps = {
	height: number;
	isDivider?: boolean;
};

const SeparatorWrapper = styled.div<{ $height: number; $isDivider?: boolean }>`
	height: ${({ $height }) => $height + 'px'};
	background: ${({ $isDivider, theme }) => $isDivider && theme.colors.transparent.light15};
`;

const Separator: React.FC<OwnProps> = ({ height, isDivider }) => {
	return <SeparatorWrapper $height={height} $isDivider={isDivider} />;
};

export { Separator };
